<!--  -->
<template>
  <div class="map-main">
    <div id="all-map" class="mapss"></div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
// import AMap from "AMap";
export default {
  //import引入的组件需要注入到对象中才能使用
  name: "mapMain",
  components: {},
  data() {
    //这里存放数据
    return {};
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    GaodeMap() {
      var map = new AMap.Map("all-map", {
        // center: [116.397428, 39.90923],
        mapStyle: "amap://styles/darkblue", //设置地图的显示样式

        // mapStyle: 'amap://styles/ef01ccf9316fe3f2152319643c31dca4', //设置地图的显示样式

        // [纬度，经度]
        resizeEnable: true,
        zoom: 5
      });
      // AMap.plugin(["AMap.ToolBar", "AMap.Scale"], function() {
      //   map.addControl(new AMap.ToolBar());
      //   map.addControl(new AMap.Scale());
      // });
      // map.setFeatures(['road','point']); // 多个种类要素显示
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.GaodeMap();
  },
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang="scss" scoped>
.mapss {
  margin: 32px auto 0;
  width: 99%;
  height: 370px;
}
//@import url(); 引入公共css类
</style>
